/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 875
// module chunks = 2